var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.49999 16C9.40388 16 9.3078 15.9758 9.22171 15.9274C9.12819 15.8749 6.90642 14.6188 4.65278 12.7263C3.31707 11.6046 2.25085 10.4921 1.4838 9.41967C0.4912 8.03196 -0.00795681 6.69715 9.58935e-05 5.45227C0.00952164 4.00371 0.542373 2.64144 1.50061 1.61636C2.47502 0.574003 3.77541 0 5.16229 0C6.93971 0 8.56476 0.969439 9.50003 2.50515C10.4353 0.969475 12.0603 0 13.8378 0C15.148 0 16.3981 0.517925 17.3579 1.45839C18.4112 2.49044 19.0097 3.94868 18.9999 5.45914C18.9918 6.70184 18.4833 8.03463 17.4885 9.42043C16.7191 10.4923 15.6543 11.6043 14.3239 12.7257C12.0785 14.618 9.87264 15.874 9.77983 15.9266C9.69333 15.9755 9.59662 16 9.49999 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledHeart);
export default __webpack_public_path__ + "static/media/filled-heart.653a4bbaf656d2cd68b23e6215eab40f.svg";
export { ForwardRef as ReactComponent };